import { getAuthToken } from "./pmApi";

export async function uploadAttachmentFile(file) {
  const token = await getAuthToken();
  const body = new FormData();
  body.set("file", file);
  body.set("folder", "attachments");

  const uploadRes = await fetch("/api/local-upload", {
    method: "POST",
    headers: {
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body,
  });
  const uploadJson = await uploadRes.json();
  if (!uploadRes.ok) throw new Error(uploadJson.error || "อัปโหลดไฟล์ไม่สำเร็จ");
  return uploadJson;
}

export function proxiedUrl(url) {
  return `/api/attachment-file?url=${encodeURIComponent(url)}`;
}
